//#region src/services/rpc-server-events.ts
var RPCServerEventsExplicitSubscribe = /* @__PURE__ */ new Set([
	"OpsActivityFeedUpdated",
	"UserGeoLocationChanged",
	"UserConnectedStateChanged",
	"UserPhysicalActivityChanged"
]);
//#endregion
export { RPCServerEventsExplicitSubscribe };

//# sourceMappingURL=rpc-server-events.js.map